import i18n from "~/plugins/i18n";
export default {
    fields: [
        {
            key: "_selected",
            label: "",
            sortable: false,
            active: true,
            fixed: true,
            filter: false,
            _filter: false,
        },
        {
            key: "id",
            label: "#",
            sorter: true,
            fixed: true,
            filter: false,
            _filter: false,
        },
        {
            key: "name",
            label: "name",
            sorter: true,
            filter: true,
            _filter: true,
        },
        {
            key: "quality",
            label: "quality",
            sorter: true,
            filter: false,
            _filter: false,
            _style: "width:5%",
        },
        {
            key: "ok",
            label: "ok",
            sorter: false,
            _filter: false,
            filter: false,
        },
        {
            key: "OriginCampaings",
            label: "input_campaings",
            sorter: false,
            _filter: false,
            filter: false,
        },
        {
            key: "OutgoingCampaings",
            label: "outgoing_campaings",
            sorter: false,
            filter: false,
            _filter: false,
        },
        {
            key: "activity",
            label: "activity",
            _style: "width:2%",
            sorter: true,
            filter: false,
            _filter: false,
            _import:false
        },
        {
            key: "created_at",
            label: "created_at",
            _style: "width:10%",
            sorter: false,
            filter: false,
            _filter: false,
        }
    ],
    allFields: [],
    items: [],
    order: "desc",
    rows: 5,
    page: 1,
    total_pages: 1,
    loading: true,
    hover: true,
    pagination: true,
    sorter: {
        external: true,
        resetable: true
    },
    sorterValue: {},
    size: "sm",
    columnFilter: {
        external: true,
        lazy: true
    },
    columnFilterValue: {},
    itemsPerPageSelect: true,
    itemSelected: null
}